import React from "react";
import { MapPin, PhoneCall } from "lucide-react";

const AREAS = ["Calgary", "Airdrie", "Chestermere", "Cochrane", "Okotoks", "Rocky View County", "Nearby communities"];

export const ServiceArea = () => (
  <section id="service-area" className="section-mv bg-white">
    <div className="container-mv grid lg:grid-cols-12 gap-10 items-stretch">
      <div className="lg:col-span-7 rounded-2xl overflow-hidden border border-neutral-200 shadow-premium">
        <iframe
          title="Mavtech Service Area — Calgary"
          src="https://www.google.com/maps?q=Calgary%2C%20Alberta&z=9&output=embed"
          className="w-full h-[420px] md:h-[520px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="lg:col-span-5">
        <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">Service Area</div>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-black">
          Proudly serving <span className="text-brand-red">Calgary &amp; area.</span>
        </h2>
        <p className="mt-4 text-neutral-600 text-base leading-relaxed">
          If you're within our service radius, we'll come to you. Outside our regular zone? Give us a call — we frequently service nearby communities.
        </p>

        <div className="mt-6 flex flex-wrap gap-2">
          {AREAS.map((a) => (
            <span key={a} className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-brand-surface px-4 py-2 text-sm font-medium text-brand-black">
              <MapPin className="w-3.5 h-3.5 text-brand-red" /> {a}
            </span>
          ))}
        </div>

        <div className="mt-8 rounded-xl bg-brand-black text-white p-6">
          <div className="text-sm text-white/70">Not sure if you're within our service area?</div>
          <a href="tel:4034043515" className="mt-2 inline-flex items-center gap-2 font-display font-bold text-xl hover:text-brand-red transition-colors">
            <PhoneCall className="w-5 h-5 text-brand-red" /> Give us a call — 403-404-3515
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ServiceArea;
